import { useIsCslUser } from 'src/auth/hooks/useIsCslUser';
import { AccountSingleSearchFilter } from 'src/common/components/Filters/Inputs/accounts/AccountSingleSearchFilter';
import {
  TableLayout,
  TableLayoutActions,
  TableLayoutFilters,
  TableLayoutSearchInput,
  TableLayoutTable,
} from 'src/common/components/Layouts/TableLayout/TableLayout';
import { productSummaryQueries } from './Inventory/queries/productSummaryQueries';
import { RefetchQueryButton } from 'src/common/components/Queries/RefetchQueryButton';
import { SuspenseLoadingView } from 'src/common/components/SuspenseLoadingView';
import { TableSkeleton } from 'src/common/components/Table/TableSkeleton';
import { ContentBox } from 'src/common/components/AppLayout/ContentBox';
import { accountsProductSummaryAtom } from 'src/atoms/filters/product-summary';
import {
  productSummaryAccountsHintsAtom,
  productSummaryUpdateHintsAtom,
} from 'src/atoms/hints/product-summary';
import { ProductSummaryInventory } from './Inventory/ProductSummaryInventory';
import { useSetAtom } from 'jotai';

export const ProductSummary = () => {
  const isCslUser = useIsCslUser();

  const setHints = useSetAtom(productSummaryUpdateHintsAtom);
  return (
    <TableLayout firstTab>
      {isCslUser && (
        <>
          <TableLayoutFilters>
            <TableLayoutSearchInput>
              <AccountSingleSearchFilter
                accountsFilterAtom={accountsProductSummaryAtom}
                accountsHintsAtom={productSummaryAccountsHintsAtom}
                onAccountSelected={(option) => {
                  if (option !== null && option.id !== null) {
                    setHints({ accounts: [option.id] });
                  }
                }}
              />
            </TableLayoutSearchInput>
          </TableLayoutFilters>
          <TableLayoutActions>
            <RefetchQueryButton queryKey={productSummaryQueries.all} />
          </TableLayoutActions>
        </>
      )}
      <TableLayoutTable>
        <SuspenseLoadingView
          loadFallback={
            <ContentBox>
              <TableSkeleton showStartSkeleton numberOfRows={20} />
            </ContentBox>
          }
          queryKey={productSummaryQueries.all}
        >
          <ProductSummaryInventory />
        </SuspenseLoadingView>
      </TableLayoutTable>
    </TableLayout>
  );
};
